import { create } from 'zustand';

interface TemplateApplyState {
  isApplying: boolean;
  templateName: string;
  stage: string;
  progress: number;
  start: (templateName: string) => void;
  update: (progress: number, stage: string) => void;
  finish: () => void;
}

export const useTemplateApplyStore = create<TemplateApplyState>((set) => ({
  isApplying: false,
  templateName: '',
  stage: '',
  progress: 0,
  start: (templateName) => set({
    isApplying: true,
    templateName,
    stage: '템플릿 적용을 준비하고 있습니다...',
    progress: 0,
  }),
  update: (progress, stage) => set((state) => ({
    ...state,
    progress: Math.max(0, Math.min(100, progress)),
    stage,
  })),
  finish: () => set({
    isApplying: false,
    templateName: '',
    stage: '',
    progress: 0,
  }),
}));
